import ClientOnly from '@g4g/ui/src/utility/ClientOnly'
import type { FC } from 'react'
import { useRecipientSelect } from '../page/RecipientSelectProvider'
import GiftSection from '../gift/GiftSection'
import RecipientLogin from './RecipientLogin'
import RecipientRecent from './RecipientRecent'

const RecipientSection: FC = () => {
  const { searchQuery } = useRecipientSelect()

  return (
    <div data-cy="shop-recipient-gift" className="flex flex-col">
      <div data-cy="shop-recipient-gift-options">
        {searchQuery === '' || searchQuery.length < 2 ? (
          <div className="flex flex-col w-full mb-16 space-y-4">
            <ClientOnly>
              <RecipientLogin />
              <RecipientRecent />
            </ClientOnly>
          </div>
        ) : (
          <div className="flex flex-col w-full mb-16 space-y-4">
            <GiftSection />
          </div>
        )}
      </div>
    </div>
  )
}

export default RecipientSection
